import React from 'react'
import { Modal, Button } from "react-bootstrap";

export default function ModalDelete({ modalTitle, modalBody, ...props }) {
    return (
        <Modal {...props}
            backdrop="static"
            keyboard={false} centered>
            <Modal.Header>
                <Modal.Title>Delete {modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you want to delete <b>{modalTitle} - {modalBody}</b>?</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={props.onSubmit}>
                    Delete {modalTitle}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

